import { featureFlagKey } from "@redotech/feature-flags-model/keys";

export const OmsFlagKey = {
  TEMU_INTEGRATION: featureFlagKey("temu-integration"), // Gate the Temu OMS integration card in fulfillment settings (default OFF until Temu approves our app; turn on per-team/globally post-approval)
  NEW_SHIPMENT_DETAILS: featureFlagKey("new-shipment-details"), // Gate the redesigned shipment details workspace in Shipping > Fulfillments
  NEW_SHIPMENT_DETAILS_USER_PREVIEW: featureFlagKey(
    "new-shipment-details-user-preview",
  ), // User-scoped preview access for the redesigned shipment details workspace before team rollout
  MERCHANT_ONBOARDING_OMS: featureFlagKey("merchant-onboarding-oms"), // Enable new OMS onboarding flow (default: show Calendly)
  REDO_3PL_INTEREST_SURVEY: featureFlagKey("redo-3-pl-interest-survey"), // Gate the 3PL interest survey onboarding to targeted OMS admin users
  OMS_TRACKSTAR_BIN_CACHE: featureFlagKey("oms-trackstar-bin-cache"), // Phase 1 shadow-read parity for OMS inventory cache Redis migration
  FULFILLMENT_GROUP_HYDRATION_BATCH_SIZE: featureFlagKey(
    "oms-fulfillment-group-hydration-batch-size",
  ),
  FORECASTING_MONTHLY_VIEW: featureFlagKey("forecasting-monthly-view"), // Gate the Monthly Forecast view. Targeted per team; default OFF.
  FORECASTING_PO: featureFlagKey("forecasting-po"), // Gate forecasting PO recommendations. Targeted per team; default OFF.
  IMS_QUICKBOOKS: featureFlagKey("ims-quickbooks"), // Gate the QuickBooks accounting settings entry for IMS teams. Targeted per team; default OFF.
} as const;
